var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main_body"},[_c('div',{staticClass:"main_box"},[_c('videoView',{attrs:{"liveId":_vm.liveId,"detail":_vm.detail,"tUid":_vm.tUid,"showRe":_vm.show},on:{"getFollow":_vm.getFollow}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }